module.exports = __webpack_public_path__ + "static/img/9.257dadf.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/6/1/zh/9.png
// module id = 7NoF
// module chunks = 0